import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { InputAdornment, TextField } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField'

import withFormFunctionality, { FormElementProps } from '~shared/components/reactHookForm/withFormFunctionality.hoc'

// improvement proposal -- implement modifying value onChange
// improvement proposal -- implement modifying value onBlur
type Props = Omit<TextFieldProps, 'value'> & FormElementProps & {
  prefix?: string
  suffix?: string
}

const FormTextField: React.FC<Props> = (props) => {
  const { validationError, defaultValue, prefix, suffix, ...rest } = props
  const { control } = useFormContext()

  return <Controller
    control={control}
    name={props.name}
    defaultValue={defaultValue || ''}
    render={(controllerProps) => {
      const handleOnBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onBlur && props.onBlur(event)
        controllerProps.onBlur()
      }

      const handleOnChange = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onChange && props.onChange(event)
        controllerProps.onChange(event)
      }

      return <TextField
        fullWidth
        variant='standard'
        error={!!validationError}
        InputProps={{
          startAdornment: prefix && <InputAdornment position='start'>{prefix}</InputAdornment>,
          endAdornment: suffix && <InputAdornment position='start'>{suffix}</InputAdornment>,
        }}
        {...rest}
        value={controllerProps.value}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        helperText={validationError?.message || props.helperText}
      />
    }}
  />
}

export default withFormFunctionality<Props>(FormTextField)
